// extracted by mini-css-extract-plugin
export default {"header":"foodCategoryHeader_header__hCyUt","title":"foodCategoryHeader_title__r8vZF"};